export default {
  FILES_CHANGE: 'FILES_CHANGE',
  WORK_CHANGE: 'WORK_CHANGE',
  FILELISTMODAL_CHANGE: 'FILELISTMODAL_CHANGE',
  PROCESSPERCENT_CHANGE: 'PROCESSPERCENT_CHANGE',
  TOKENID_CHANGE: 'TOKENID_CHANGE',
  PREUPLOADFILE_CHANGE: 'PREUPLOADFILE_CHANGE',
  UPLOADING_CHANGE: 'UPLOADING_CHANGE',
  UPLOADPERCENT_CHANGE: 'UPLOADPERCENT_CHANGE',
  PROGRESSSTEP_CHANGE: 'PROGRESSSTEP_CHANGE',
  HANDLEIMGERR_CHANGE: 'HANDLEIMGERR_CHANGE',
  CURRPROGRESS_CHANGE: 'CURRPROGRESS_CHANGE',
  STARTTIME_CHANGE: 'STARTTIME_CHANGE',
  CURRFILE_CHANGE: 'CURRFILE_CHANGE',
  CANCELPROGRESS_CHANGE: 'CANCELPROGRESS_CHANGE',
  USERACTION_CHANGE: 'USERACTION_CHANGE',
  FILETOBLOBSTATUS_CHANGE: 'FILETOBLOBSTATUS_CHANGE',
  SUBMITTING_CHANGE: 'SUBMITTING_CHANGE',
  UPLOADAGAINFILE_CHANGE: 'UPLOADAGAINFILE_CHANGE',
  UPLOADXHR_CHANGE: 'UPLOADXHR_CHANGE',
  FETCHABORT_CHANGE: 'FETCHABORT_CHANGE',

  TOGIFOBJ_CHANGE: 'TOGIFOBJ_CHANGE',
  CROP_CHANGE: 'CROP_CHANGE',
  AUDIOCOMPRESSLIST_CHANGE: 'AUDIOCOMPRESSLIST_CHANGE',
  AUDIOEXTRACTORFILE_CHANGE: 'AUDIOEXTRACTORFILE_CHANGE',
  AUDIOJOINERLIST_CHANGE: 'AUDIOJOINERLIST_CHANGE',
  AUDIOCUTSPEEDVOLUMEOBJ_CHANGE: 'AUDIOCUTSPEEDVOLUMEOBJ_CHANGE',
  AUDIOADDMUSICLIST_CHANGE: 'AUDIOADDMUSICLIST_CHANGE',
  VIDEOCOMPRESSOBJ_CHANGE: 'VIDEOCOMPRESSOBJ_CHANGE',
  VIDEOMUTEOBJ_CHANGE: 'VIDEOMUTEOBJ_CHANGE',
  IMAGECUTOUTOBJ_CHANGE: 'IMAGECUTOUTOBJ_CHANGE',

  AUTHORIZATION_CHANGE: 'AUTHORIZATION_CHANGE', //认证信息
  PURCHASEMODALOBJ_CHANGE: 'PURCHASEMODALOBJ_CHANGE', //购买弹窗
  PROFILEOBJ_CHANGE: 'PROFILEOBJ_CHANGE', //用户个人信息
  SUBSCRIPTION_CHANGE: 'SUBSCRIPTION_CHANGE', //订阅信息
  VIDEOEDITORTIMES_CHANGE: 'VIDEOEDITORTIMES_CHANGE',
  IMAGECUTOUTTIMES_CHANGE: 'IMAGECUTOUTTIMES_CHANGE',
  OPEN_ADVERTISE: 'OPEN_ADVERTISE',
  ADVERTISE_CONFIG: 'ADVERTISE_CONFIG',
  DOWNLOAD_PERCENT: 'DOWNLOAD_PERCENT',
  HIDE_LINK: 'HIDE_LINK',
  PAYBILL: 'PAYBILL',
  PATRIGTER: 'PATRIGTER',
  EXCEED2M: 'EXCEED2M',
  SAVESKU: 'SAVESKU',
  SAVESWITCHOTHER: 'SAVESWITCHOTHER',
  SIGNUPMODAL: 'SIGNUPMODAL',
  LOGININ: 'LOGININ', //登录
  LOGINOUT: 'LOGINOUT',
  SENDVERIFICATION: 'SENDVERIFICATION',
  SIGNUPWIDTHEMAIL: 'SIGNUPWIDTHEMAIL',
  SAVEEMAIL: 'SAVEEMAIL',
};
